import React, { useState, useEffect, forwardRef } from "react";
import styles from "./OuterServicesResult.module.scss";
import { OuterServiceResultType } from "types";
import { Location } from "assets/icons";
import Text from "components/text/Text";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import strings from "assets/strings";
//import { getAllClassNames,  } from "helpers";
import { settings } from "assets/settings";
import PhoneLink from "components/phoneLink/PhoneLink";
//import { SimpleDropdown } from "components/simpleDropdown/SimpleDropdown";
import { hearingCategories } from "assets/constants";

interface Price {
  name: string;
  price: number;
}

interface Option {
  option: string;
  prices: Price[];
}

export const OuterServicesResult = forwardRef(({ hit }: { hit: OuterServiceResultType }, ref: any) => {
  const onNavigate = (hit: OuterServiceResultType) => {
    const { city, street, houseNum } = hit;
    const address = `${street || ''} ${houseNum || ''} ${city || ''}`;
    const encodedAddress = encodeURIComponent(address);
    const mobileUrl = `geo://0,0?q=${encodedAddress}`;
    const iosUrl = `maps://?q=${encodedAddress}`;
    const desktopUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    function isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    const url = isMobile() ? (isIOS() ? iosUrl : mobileUrl) : desktopUrl;
    window.open(url, "_blank");

  };

  const [showCategoriesOptions, setShowCategoriesOptions] = useState(false);
  const [isHearingAidCombined, setIsHearingAidCombined] = useState(false);
  const [hearingAidCombinedOptions, sethearingAidCombinedOptions] = useState<Option[]>([]);
  const [optionPrices, setOptionPrices] = useState<Price[]>([]);

  const showOptionPrices = (selectedOption: string) => {
    const selectedOptionPrices = hearingAidCombinedOptions.find(option => option.option === selectedOption);
    if (selectedOptionPrices) {
      setOptionPrices(selectedOptionPrices.prices);
    }   
  }

  const handleClick = () => {
    setShowCategoriesOptions(!showCategoriesOptions);
    showOptionPrices(hearingAidCombinedOptions[0]?.option)
  }

  useEffect(() => {
    if (hit.hearingAidCombined) {
      //temporary solution for hearing aid combined
      setIsHearingAidCombined(false);
      let options: Option[] = [];
      options = hit.hearingAidCombined.map((option) => {
        return {
          option: option.treatmentDescription,
          prices: [
            { name: strings.medicalCentersSearchResults.healthServices, price: Number(option.price) },
            { name: strings.medicalCentersSearchResults.leumitSilver, price: Number(option.silverPrice) },
            { name: strings.medicalCentersSearchResults.leumitGold, price: Number(option.goldPrice) }
          ]
        };
      });      
      sethearingAidCombinedOptions(options);
    }
  }, []);

  return (
    <>
      <div className={styles.hitMedicalCenter} ref={ref}>
        <div className={styles.distanceSection}>
          {hit._rankingInfo?.geoDistance && (
            <Text className={styles.textTitle2} text={`${(hit._rankingInfo.geoDistance / 1000).toFixed(2)} ק"מ`} />
          )}
        </div>
        <div className={styles.medicalCenterDetails}>
          <div className={styles.section2}>
            <SvgGenerator name="Icon" className={styles.avatar} objectName="outerServicesSearchResults" fallBackIcon="OuterService" />
            <div className={styles.divText}>
              <a href={`${settings.outerServicePage}?supplierCode=${hit.supplierCode || ''}`} className={styles.textTitle}>
                {`${hit.name}`}
              </a>
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.divText}>
              <Text
                className={styles.textTitle2}
                text={strings.globalStrings.address}
              />
              <Text
                className={styles.textAddress}
                text={`${hit.street || ''} ${hit.houseNum || ''}, ${hit.city || ''} `}
              />
              <span onClick={() => onNavigate(hit)} className={styles.spanClick}>
                <Location className={styles.icon} />
                <Text
                  className={styles.textNavigate}
                  text={strings.medicalCentersSearchResults.navigateToAddress}
                />
              </span>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.divText2}>
              {(hit.phone1 || hit.phone2) && <Text
                className={styles.textTitle2}
                text={strings.medicalCentersSearchResults.callToOrder}
              />}
              {hit.phone1 && (
                <PhoneLink phoneNumber={String(hit.phone1)} />
              )}
              {hit.phone2 && (
                <PhoneLink phoneNumber={String(hit.phone2)} />
              )}
            </div>
          </div>
        </div>
        {isHearingAidCombined &&
          <div className={styles.amountToggleTitle} onClick={handleClick} tabIndex={0} role="button">
            <span className={styles.participationSum}>{strings.medicalCentersSearchResults.participationAmount}</span>

            {showCategoriesOptions ? <SvgGenerator name="ArrowUp2" className={styles.arrowIcon} objectName="medicalCenterSearchResults" /> : <SvgGenerator name="ArrowLeft2" className={styles.arrowIcon} objectName="medicalCenterSearchResults" />}
          </div>
        }
        {showCategoriesOptions && <div className={styles.optionsContainer}>
          {/*Hided according to leumit reqiest*/}
          {/* <SimpleDropdown
            selectOptions={hearingAidCombinedOptions.map(option => ({ value: option.option, label: option.option, isSelected: false }))}
            title={strings.medicalCentersSearchResults.chooseDeviceCategory}
            onChange={(selectedOption: string) => showOptionPrices(selectedOption)}
            slectedValue={hearingAidCombinedOptions[0]?.option} /> */}
          <div className={styles.pricesSection}>
            {optionPrices.map((price, index) => (
              <div key={index}>
                <div className={styles.priceItem}>
                  <div className={styles.categoryType}>
                    <SvgGenerator name={hearingCategories[index] as "Basic" | "Silver" | "Gold"} className={styles.levelIcon} objectName="outerServicesSearchResults" />
                    <Text
                      className={styles.titleHearring}
                      text={price.name}
                    />
                  </div>
                  <Text
                    className={styles.titleHearring}
                    text={price.price > 0 ? `${price.price} ${strings.medicalCentersSearchResults.nis}` : strings.medicalCentersSearchResults.noDeductible}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>}
      </div>

    </>
  );
});
